import { render, staticRenderFns } from "./MInplayCartNew.vue?vue&type=template&id=522d7804&scoped=true"
import script from "./MInplayCartNew.vue?vue&type=script&lang=js"
export * from "./MInplayCartNew.vue?vue&type=script&lang=js"
import style0 from "./MInplayCartNew.vue?vue&type=style&index=0&id=522d7804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522d7804",
  null
  
)

export default component.exports